export default [
    {
        path: '/global-calendar',
        name: 'Workspace Calendar',
        component: () => import('@/views/calendar/WorkspaceCalendar.vue'),
        meta: {
            layout: 'Default',
            abilities: [['manage', 'workspace-members']],
            nav: 'workspace-calendar' 
        }
    }
]
